import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RecruitingPage } from './pages/RecruitingPage';
import { AgentPortal } from './pages/AgentPortal';
const SITE_TITLE = 'Where Ambition Meets Opportunity';
const SITE_DESCRIPTION = 'Broker Elevation — Where Ambition Meets Opportunity.';
const SITE_IMAGE = 'https://cdn.magicpatterns.com/uploads/kRybL6nc1toe2tMoAuDrgk/IMG_1492.jpg';
/** Sets document title + social/meta tags at runtime (no editable index.html in this project). */
function useSiteMetadata() {
  useEffect(() => {
    document.title = SITE_TITLE;
    const upsertMeta = (selector: string, attr: 'name' | 'property', key: string, content: string) => {
      let el = document.head.querySelector<HTMLMetaElement>(selector);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    upsertMeta('meta[name="description"]', 'name', 'description', SITE_DESCRIPTION);
    // Open Graph
    upsertMeta('meta[property="og:title"]', 'property', 'og:title', SITE_TITLE);
    upsertMeta('meta[property="og:description"]', 'property', 'og:description', SITE_DESCRIPTION);
    upsertMeta('meta[property="og:image"]', 'property', 'og:image', SITE_IMAGE);
    upsertMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
    // Twitter
    upsertMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
    upsertMeta('meta[name="twitter:title"]', 'name', 'twitter:title', SITE_TITLE);
    upsertMeta('meta[name="twitter:description"]', 'name', 'twitter:description', SITE_DESCRIPTION);
    upsertMeta('meta[name="twitter:image"]', 'name', 'twitter:image', SITE_IMAGE);
  }, []);
}
export function App() {
  useSiteMetadata();
  return <BrowserRouter data-id="element-0" data-mp="38b7cycbvyf1">
      <Routes data-id="element-1" data-mp="3ud1en72ulk9k">
        <Route path="/" element={<RecruitingPage data-id="element-3" data-mp="3ubzvsgflbtha" />} data-id="element-2" data-mp="3udkmfuysas9v" />
        <Route path="/agents" element={<AgentPortal data-id="element-5" data-mp="d57g95652mk4" />} data-id="element-4" data-mp="3uf5ixq4nslad" />
      </Routes>
    </BrowserRouter>;
}